import { SYNC_LIMIT_HIGH } from '@/utilities/constants';

import { MiningPatternDocument } from '../MiningPattern/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { RoomDocument } from '../Rooms/queryBuilder';
import { SiteDocument } from '../Site/queryBuilder';
import { SurveyPointDocument, surveyPointsPullQueryBuilder } from './queryBuilder';

export function surveyPointsFamilyMember(
  configBuilder: ConfigBuilder,
  miningPatterns: FamilyMember<MiningPatternDocument>,
  rooms: FamilyMember<RoomDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<SurveyPointDocument> {
  const syncConfig = configBuilder<SurveyPointDocument>(RxdbCollectionNameV2.SURVEY_POINTS);
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, surveyPointsPullQueryBuilder);
  pullConfig.batchSize = SYNC_LIMIT_HIGH;

  const replicationState = replicate(syncConfig);
  // Legacy syncInterval was LiveInterval.SECONDS_60,
  return create(RxdbCollectionNameV2.SURVEY_POINTS, replicationState, [
    miningPatterns,
    rooms,
    sites,
  ]);
}
